import MENU_UI_ACTIONS from '../app/data/MenuUiActionConstants';
import PAGES from '../app/data/PagesConstants';

const setupDashboardMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_dashboard.title,
    MENU_UI_ACTIONS.view_dashboard.name,
    PAGES.DashboardPage.name
  )
}

const setupGeoConfigurationMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_geo_config_menu.title,
    MENU_UI_ACTIONS.view_geo_config_menu.name,
  ).addChildMenus(
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_circles_list.title,
      MENU_UI_ACTIONS.view_circles_list.name,
      PAGES.CirclesListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_clusters_list.title,
      MENU_UI_ACTIONS.view_clusters_list.name,
      PAGES.ClustersListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_states_list.title,
      MENU_UI_ACTIONS.view_states_list.name,
      PAGES.StatesListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_pincodes_list.title,
      MENU_UI_ACTIONS.view_pincodes_list.name,
      PAGES.PincodesListingPage.name
    ),
  )

  uiManager.getUiPage(PAGES.NewCirclePage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_circles_list.name))
  uiManager.getUiPage(PAGES.ShowCirclePage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_circles_list.name))
  uiManager.getUiPage(PAGES.EditCirclePage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_circles_list.name))
  uiManager.getUiPage(PAGES.NewPinCodePage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_pincodes_list.name))
  uiManager.getUiPage(PAGES.EditPinCodePage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_pincodes_list.name))
  uiManager.getUiPage(PAGES.NewClusterPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_clusters_list.name))
  uiManager.getUiPage(PAGES.ShowClusterPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_clusters_list.name))
  uiManager.getUiPage(PAGES.EditClusterPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_clusters_list.name))

}

const setupUserListMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_users_list_menu.title,
    MENU_UI_ACTIONS.view_users_list_menu.name
  ).addChildMenus(
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_customers_list.title,
      MENU_UI_ACTIONS.view_customers_list.name,
      PAGES.CustomersListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_distributors_list.title,
      MENU_UI_ACTIONS.view_distributors_list.name,
      PAGES.DistributorsListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_fleet_owners_list.title,
      MENU_UI_ACTIONS.view_fleet_owners_list.name,
      PAGES.FleetOwnersListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_head_users_list.title,
      MENU_UI_ACTIONS.view_head_users_list.name,
      PAGES.HeadUsersListingPage.name
    )
  )

  uiManager.getUiPage(PAGES.ShowCustomerPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_customers_list.name))
  uiManager.getUiPage(PAGES.MapHeadUserPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_head_users_list.name))
  uiManager.getUiPage(PAGES.NewHeadUserPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_head_users_list.name))
  uiManager.getUiPage(PAGES.EditHeadUserPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_head_users_list.name))
  uiManager.getUiPage(PAGES.DistributorDetailsPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_distributors_list.name))
  uiManager.getUiPage(PAGES.ShowFleetOwnerPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_fleet_owners_list.name))
  uiManager.getUiPage(PAGES.LeaseOfferListingTab.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_fleet_owners_list.name))
  uiManager.getUiPage(PAGES.NewLeaseOfferPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_fleet_owners_list.name))
  uiManager.getUiPage(PAGES.EditLeaseOfferPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_fleet_owners_list.name))
  uiManager.getUiPage(PAGES.RolloverConfigsPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_fleet_owners_list.name))
  uiManager.getUiPage(PAGES.NewRollOverConfigPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_fleet_owners_list.name))
  uiManager.getUiPage(PAGES.EditRollOverConfigPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_fleet_owners_list.name))
}

const setupInventoryMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_inventory_menu.title,
    MENU_UI_ACTIONS.view_inventory_menu.name
  ).addChildMenus(
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_batteries_listing.title,
      MENU_UI_ACTIONS.view_batteries_listing.name,
      PAGES.BatteriesListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_vehicles_menu.title,
      MENU_UI_ACTIONS.view_vehicles_menu.name,
    ).addChildMenus(
      uiManager.addMenuItem(
        MENU_UI_ACTIONS.view_vehicles_list.title,
        MENU_UI_ACTIONS.view_vehicles_list.name,
        PAGES.VehiclesListingPage.name
      ),
      uiManager.addMenuItem(
        MENU_UI_ACTIONS.view_vehicle_types_list.title,
        MENU_UI_ACTIONS.view_vehicle_types_list.name,
        PAGES.VehicleTypesListingPage.name
      ),
      uiManager.addMenuItem(
        MENU_UI_ACTIONS.view_vehicle_inspection_items_list.title,
        MENU_UI_ACTIONS.view_vehicle_inspection_items_list.name,
        PAGES.InspectionsItemsPage.name
      ),
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_warehouses_listing.title,
      MENU_UI_ACTIONS.view_warehouses_listing.name,
      PAGES.WarehousesListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_battery_models_listing.title,
      MENU_UI_ACTIONS.view_battery_models_listing.name,
      PAGES.BatteryModelsListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_charging_stations_menu.title,
      MENU_UI_ACTIONS.view_charging_stations_menu.name,
    ).addChildMenus(
      uiManager.addMenuItem(
        MENU_UI_ACTIONS.view_charging_stations_listing.title,
        MENU_UI_ACTIONS.view_charging_stations_listing.name,
        PAGES.ChargingStationsListingPage.name
      ),
      uiManager.addMenuItem(
        MENU_UI_ACTIONS.view_cs_diagnostics_menu_page.title,
        MENU_UI_ACTIONS.view_cs_diagnostics_menu_page.name,
        PAGES.ChargingStationDiagnosticsPage.name
      ),
      uiManager.addMenuItem(
        MENU_UI_ACTIONS.view_cs_version_update_menu_page.title,
        MENU_UI_ACTIONS.view_cs_version_update_menu_page.name,
        PAGES.ChargingStationVersionUpdatePage.name
      )
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_rfids_list.title,
      MENU_UI_ACTIONS.view_rfids_list.name,
      PAGES.RfidCardsListingPage.name
    ),
  )

  uiManager.getUiPage(PAGES.NewBatteryModelPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_battery_models_listing.name))
  uiManager.getUiPage(PAGES.EditBatteryModelPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_battery_models_listing.name))
}

const setupPartnerReimbursementMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_partners_reimbursement_menu.title,
    MENU_UI_ACTIONS.view_partners_reimbursement_menu.name
  ).addChildMenus(
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_earnings_list.title,
      MENU_UI_ACTIONS.view_earnings_list.name,
      PAGES.EarningsListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_partner_billings_listing.title,
      MENU_UI_ACTIONS.view_partner_billings_listing.name,
      PAGES.PartnerBillingsListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_electricity_providers_list.title,
      MENU_UI_ACTIONS.view_electricity_providers_list.name,
      PAGES.ElectricityServiceProvidersListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_electricity_menu.title,
      MENU_UI_ACTIONS.view_electricity_menu.name,
    ).addChildMenus(
      uiManager.addMenuItem(
        MENU_UI_ACTIONS.view_electricity_claims_list.title,
        MENU_UI_ACTIONS.view_electricity_claims_list.name,
        PAGES.ElectricityClaimsListingPage.name
      ),
      uiManager.addMenuItem(
        MENU_UI_ACTIONS.view_electricity_configurations_list.title,
        MENU_UI_ACTIONS.view_electricity_configurations_list.name,
        PAGES.ElectricityConfigsListingPage.name
      )
    )
  )

  uiManager.getUiPage(PAGES.PartnerBillingsShowPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_partner_billings_listing.name))
  uiManager.getUiPage(PAGES.PerDayEarningShowPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_partner_billings_listing.name))
}

const setupPricingMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_pricings_menu.title,
    MENU_UI_ACTIONS.view_pricings_menu.name,
  ).addChildMenus(
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_offers_listing.title,
      MENU_UI_ACTIONS.view_offers_listing.name,
      PAGES.OffersListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_schemes_listing.title,
      MENU_UI_ACTIONS.view_schemes_listing.name,
      PAGES.SchemesListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_security_amount_listing.title,
      MENU_UI_ACTIONS.view_security_amount_listing.name,
      PAGES.SecurityAmountsListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_addons_list.title,
      MENU_UI_ACTIONS.view_addons_list.name,
      PAGES.AddonsListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_offer_addons_list.title,
      MENU_UI_ACTIONS.view_offer_addons_list.name,
      PAGES.OfferAddonsListingPage.name
    ),
  )
  uiManager.getUiPage(PAGES.NewSchemePage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_schemes_listing.name))
  uiManager.getUiPage(PAGES.EditSchemePage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_schemes_listing.name))

  uiManager.getUiPage(PAGES.NewSecurityAmountPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_security_amount_listing.name))
  uiManager.getUiPage(PAGES.EditSecurityAmountPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_security_amount_listing.name))

  uiManager.getUiPage(PAGES.NewAddonPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_addons_list.name))
  uiManager.getUiPage(PAGES.EditAddonPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_addons_list.name))

  uiManager.getUiPage(PAGES.NewOfferAddonPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_offer_addons_list.name))
  uiManager.getUiPage(PAGES.EditOfferAddonPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_offer_addons_list.name))

}

const setupAuthorizationMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_authorization_menu.title,
    MENU_UI_ACTIONS.view_authorization_menu.name,
  ).addChildMenus(
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_auth_permissions_editor.title,
      MENU_UI_ACTIONS.view_auth_permissions_editor.name,
      PAGES.PermissionsConfigPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_crm_users_list.title,
      MENU_UI_ACTIONS.view_crm_users_list.name,
      PAGES.CrmUsersListingPage.name
    )
  )

  uiManager.getUiPage(PAGES.EditCrmUserPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_crm_users_list.name))
  uiManager.getUiPage(PAGES.NewCrmUserPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_crm_users_list.name))
}

const setupWorkOrdersMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_work_orders_menu.title,
    MENU_UI_ACTIONS.view_work_orders_menu.name,
  ).addChildMenus(
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_work_orders_list.title,
      MENU_UI_ACTIONS.view_work_orders_list.name,
      PAGES.WorkOrdersListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_complaint_categories_list.title,
      MENU_UI_ACTIONS.view_complaint_categories_list.name,
      PAGES.ComplaintCategoriesListingPage.name
    )
  )

  uiManager.getUiPage(PAGES.NewComplaintCategoryPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_complaint_categories_list.name))
  uiManager.getUiPage(PAGES.EditComplaintCategoryPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_complaint_categories_list.name))
  uiManager.getUiPage(PAGES.ShowWorkOrdersPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_work_orders_list.name))
}

const setupServiceCenterMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_service_centers_list.title,
    MENU_UI_ACTIONS.view_service_centers_list.name,
    PAGES.ServiceCentersListingPage.name
  )

  uiManager.getUiPage(PAGES.NewServiceCenterPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_service_centers_list.name))
  uiManager.getUiPage(PAGES.EditServiceCenterPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_service_centers_list.name))
  uiManager.getUiPage(PAGES.ShowServiceCenterPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_service_centers_list.name))
}

const setLeadsmenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_leads_menu.title,
    MENU_UI_ACTIONS.view_leads_menu.name,
  ).addChildMenus(
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_leads_listing.title,
      MENU_UI_ACTIONS.view_leads_listing.name,
      PAGES.LeadsListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_leads_earning_configs_listing.title,
      MENU_UI_ACTIONS.view_leads_earning_configs_listing.name,
      PAGES.LeadsEarningConfigsPage.name
    ),
  )

  uiManager.getUiPage(PAGES.NewLeadsEarningConfigsPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_leads_earning_configs_listing.name))
  uiManager.getUiPage(PAGES.EditLeadsEarningConfigsPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_leads_earning_configs_listing.name))
}

const setBaasVaasMappingMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_service_type_mapping_menu.title,
    MENU_UI_ACTIONS.view_service_type_mapping_menu.name,
    PAGES.ServiceTypeMappingPage.name
  )

  uiManager.getUiPage(PAGES.NewServiceTypeMappingPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_service_type_mapping_menu.name))
}

const setupReportsMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_reports_menu.title,
    MENU_UI_ACTIONS.view_reports_menu.name,
  ).addChildMenus(
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_general_reports_listing.title,
      MENU_UI_ACTIONS.view_general_reports_listing.name,
      PAGES.GeneralReportsListingPage.name
    ),
  )
}

const setUploadsMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_uploads.title,
    MENU_UI_ACTIONS.view_uploads.name,
  ).addChildMenus(
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_uploader_history_listing.title,
      MENU_UI_ACTIONS.view_uploader_history_listing.name,
      PAGES.UploaderHistoryListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_upload_files_menu.title,
      MENU_UI_ACTIONS.view_upload_files_menu.name,
      PAGES.UploadFilesPage.name
    )
  )
}

const setupChargingZonesMapMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_charging_zones_map_menu.title,
    MENU_UI_ACTIONS.view_charging_zones_map_menu.name,
    PAGES.ChargingZonesMapPage.name
  )
}

const setupTransactionsMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_transactions_menu.title,
    MENU_UI_ACTIONS.view_transactions_menu.name,
  ).addChildMenus(
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_tally_transactions_list.title,
      MENU_UI_ACTIONS.view_tally_transactions_list.name,
      PAGES.TallyTransactionsListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_wallet_transactions_list.title,
      MENU_UI_ACTIONS.view_wallet_transactions_list.name,
      PAGES.WalletTransactionsListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_battery_transactions_list.title,
      MENU_UI_ACTIONS.view_battery_transactions_list.name,
      PAGES.BatteryTransactionsListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_transaction_orders_menu.title,
      MENU_UI_ACTIONS.view_transaction_orders_menu.name,
      PAGES.TransactionOrdersPage.name
    )
  )
}

const setupChallansMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_challans_list.title,
    MENU_UI_ACTIONS.view_challans_list.name,
    PAGES.ChallansListingPage.name
  )
}

const setupWalletCashBackMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_wallet_cashbacks_list.title,
    MENU_UI_ACTIONS.view_wallet_cashbacks_list.name,
    PAGES.WalletCashbacksListingPage.name
  )
}

const setRentalsMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_rentals_menu.title,
    MENU_UI_ACTIONS.view_rentals_menu.name,
  ).addChildMenus(
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_rental_customers_list.title,
      MENU_UI_ACTIONS.view_rental_customers_list.name,
      PAGES.RentalCustomersPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_rental_bookings_list.title,
      MENU_UI_ACTIONS.view_rental_bookings_list.name,
      PAGES.RentalBookingsPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_asset_earnings_config_list.title,
      MENU_UI_ACTIONS.view_asset_earnings_config_list.name,
      PAGES.AssetEarningsConfigPage.name
    ),
  )

  uiManager.getUiPage(PAGES.ShowRentalCustomerPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_rental_customers_list.name))
}

const setupVoltupAllocationKitMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_voltup_allocation_kit_menu.title,
    MENU_UI_ACTIONS.view_voltup_allocation_kit_menu.name,
  ).addChildMenus(
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_voltup_allocation_kit_list.title,
      MENU_UI_ACTIONS.view_voltup_allocation_kit_list.name,
      PAGES.VoltUpAllocationKitListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_voltup_allocation_kit_reports_list.title,
      MENU_UI_ACTIONS.view_voltup_allocation_kit_reports_list.name,
      PAGES.VoltUpAllocationKitReportsListingPage.name
    ),
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_voltup_allocation_kit_transactions_list.title,
      MENU_UI_ACTIONS.view_voltup_allocation_kit_transactions_list.name,
      PAGES.VoltUpAllocationKitTransactionsListingPage.name
    ),
  )

  uiManager.getUiPage(PAGES.NewVoltUpAllocationKitPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_voltup_allocation_kit_list.name))
  uiManager.getUiPage(PAGES.EditVoltUpAllocationKitPage.name).setLinkedUiMenu(uiManager.getMenuItem(MENU_UI_ACTIONS.view_voltup_allocation_kit_list.name))
}

const setSearchUserMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_search_user_menu.title,
    MENU_UI_ACTIONS.view_search_user_menu.name,
  ).addChildMenus(
    uiManager.addMenuItem(
      MENU_UI_ACTIONS.view_search_user_page.title,
      MENU_UI_ACTIONS.view_search_user_page.name,
      PAGES.SearchUserPage.name
    ),
  )
}

const setSupportMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_support_menu.title,
    MENU_UI_ACTIONS.view_support_menu.name,
    PAGES.SupportPage.name
  )
}
const setOperationsMenu = (uiManager) => {
  uiManager.addMenuItem(
    MENU_UI_ACTIONS.view_operations_menu.title,
    MENU_UI_ACTIONS.view_operations_menu.name,
    PAGES.OperationsPage.name
  )
}

const setupMenuItems = (uiManager) => {
  // setOperationsMenu(uiManager);
  setupDashboardMenu(uiManager);
  setupGeoConfigurationMenu(uiManager);
  setupUserListMenu(uiManager);
  setupInventoryMenu(uiManager);
  setupPricingMenu(uiManager);
  // setupChargingZonesMapMenu(uiManager);
  setupVoltupAllocationKitMenu(uiManager);
  setupPartnerReimbursementMenu(uiManager);
  setupWalletCashBackMenu(uiManager);
  setupAuthorizationMenu(uiManager);
  setupWorkOrdersMenu(uiManager);
  setupServiceCenterMenu(uiManager);
  setLeadsmenu(uiManager);
  setBaasVaasMappingMenu(uiManager);
  setupReportsMenu(uiManager);
  setUploadsMenu(uiManager);
  setupTransactionsMenu(uiManager);
  setupChallansMenu(uiManager);
  setRentalsMenu(uiManager);
  setSearchUserMenu(uiManager);
  setSupportMenu(uiManager);
}

export default setupMenuItems;
